export default function displayPicHandler(name) {
  const abbreviatedName = name.split(" ");
  if (abbreviatedName.length >= 2) {
    return `${Array.from(abbreviatedName[0])[0].toUpperCase()}${Array.from(
      abbreviatedName[1]
    )[0].toUpperCase()}`;
  }
  return `${Array.from(abbreviatedName[0])[0].toUpperCase()}`;
}
